const m = (s, n = !1) => {
  const e = new RegExp(/^(0*\d|1[0-2]):[0-5]\d$/), t = new RegExp(/^(0*\d|1\d|2[0-3]):[0-5]\d$/);
  return (n ? t : e).test(s);
}, l = (s, n, e, t = !1) => {
  t || (n === "pm" ? e >= 0 && e < 12 && (e += 12) : e >= 0 && e < 13 && (e = e === 12 && n === "am" ? 0 : e)), s.setHours(e);
}, a = (s, n) => {
  n >= 0 && n < 60 ? s.setMinutes(n) : s.setMinutes(0);
}, d = (s, n, e = !1) => {
  const t = /* @__PURE__ */ new Date();
  t.setSeconds(0);
  const [i, c] = s.replaceAll("H", "").replaceAll("M", "").split(":"), o = parseInt(i, 10), r = parseInt(c, 10);
  return l(t, n, o, e), a(t, r), t;
}, p = (s, n) => `${n.toString().padStart(2, "0")}:${s.getMinutes().toString().padStart(2, "0")}`, f = (s, n = !1) => {
  const e = { timeField: "", meridiem: "am" };
  let t = s.getHours();
  return n || (e.meridiem = t >= 12 ? "pm" : "am", t >= 12 && (t -= 12), t === 0 && e.meridiem === "pm" && (t = 12)), e.timeField = p(s, t), e;
};
export {
  f as convertDateToTimeInput,
  d as convertTimeInputToDateString,
  m as isTimeStringValid
};
